$(document).ready(function () {
  const MAX_RETRIES = 10; // Maximum number of retry attempts
  const INITIAL_DELAY = 200; // Initial delay in ms
  const BACKOFF_FACTOR = 1.5; // How much to increase delay each retry
  
  const applyPriceUpdate = () => {
      $('.tolstoy-product-tile-title').each(function () {
          const titleText = $(this).text().trim();

          if (/\(3-Month\)/.test(titleText)) {

              // Traverse up and locate the container
              const container = $(this).closest('tolstoy-carousel > div > div.tolstoy-carousel-videos-container > div > div > div.tolstoy-product-content > div:nth-child(1) > div > div');
              const subtitleElement = container.find('.tolstoy-product-tile-subtitle');

              if (subtitleElement.length && !subtitleElement.data('modified')) {
                  const priceText = subtitleElement.text().trim();

                  const priceNumber = parseFloat(priceText.replace('$', ''));
                  if (!isNaN(priceNumber)) {
                      const multipliedPrice = (priceNumber * 2);

                      subtitleElement.html(`$${multipliedPrice}`);
                      subtitleElement.data('modified', true);
                  } 
              } 
          }
      });
  };

  const checkElementsAndApply = (attempt = 0, delay = INITIAL_DELAY) => {
      console.log(`Checking for elements (attempt ${attempt + 1})...`);
      
      // Check if the carousel container exists
      const carouselContainer = $('.tolstoy-carousel-videos-container');
      
      if (carouselContainer.length) {
          console.log('Carousel container found! Applying price updates...');
          
          setInterval(() => {
              applyPriceUpdate();
          }, 1000);
          
          // Set up MutationObserver for future changes
          console.log('Setting up MutationObserver for carousel...');
          const observer = new MutationObserver(() => {
              console.log('Mutation detected — running price update again.');
              applyPriceUpdate();
          });
          
          observer.observe(carouselContainer[0], {
              childList: true,
              subtree: true,
              attributes: true,
              characterData: true
          });
          
          return; // Success - exit the retry loop
      }
      
      // If elements not found and we haven't exceeded max retries
      if (attempt < MAX_RETRIES - 1) {
          const nextDelay = Math.min(delay * BACKOFF_FACTOR, 5000); // Cap at 5s
          
          setTimeout(() => {
              checkElementsAndApply(attempt + 1, nextDelay);
          }, delay);
      }
  };

  // Start the initial check
  checkElementsAndApply();
});


// Wait for Tolstoy widget to be ready before processing
window.addEventListener("tolstoyWidgetReady", function() {
  console.log("🚀 Tolstoy Widget Ready - Starting Product Tile Processor");

  // Find ALL divs with data-is-expanded="true"
  const expandedDivs = document.querySelectorAll('div[data-is-expanded="true"]');

  console.log(`Found ${expandedDivs.length} expanded divs`);

  // Process each expanded div
  expandedDivs.forEach((expandedDiv, divIndex) => {
    console.log(`\n=== Processing Expanded Div ${divIndex + 1} ===`);
    
    // Get all direct children with class .tolstoy-product-tile
    const allProductTiles = expandedDiv.querySelectorAll(':scope > .tolstoy-product-tile');
    
    // Get all tiles starting from the second child (exclude first child)
    const productTilesFromSecond = Array.from(allProductTiles).slice(1);
    
    console.log(`Found ${productTilesFromSecond.length} product tiles (excluding first child) in div ${divIndex + 1}`);
    
    // Process each tile
    productTilesFromSecond.forEach((tile, index) => {
      // Find title and subtitle elements within this tile
      const titleElement = tile.querySelector('.tolstoy-product-tile-title');
      const subtitleElement = tile.querySelector('.tolstoy-product-tile-subtitle');
      
      if (titleElement && subtitleElement) {
        const titleText = titleElement.textContent.trim();
        const subtitleText = subtitleElement.textContent.trim();
        
        console.log(`\n  Tile ${index + 2} (Div ${divIndex + 1}):`); // +2 because we're starting from second child
        console.log(`  Title: "${titleText}"`);
        console.log(`  Subtitle: "${subtitleText}"`);
        
        // Check if title contains "(3-Month)"
        if (titleText.includes('(3-Month)')) {
          console.log('  ✓ Title contains "(3-Month)"');
          
          // Check if there are compare price elements (strikethrough/compare spans)
          const compareSpans = subtitleElement.querySelectorAll('span[class*="compare"], span[class*="Compare"], span[style*="text-decoration"], span[style*="line-through"]');
          
          let numberToMultiply = null;
          let isComparePrice = false;
          
          if (compareSpans.length > 0) {
            // Scenario 1: Has compare price - get main price OUTSIDE the compare span
            isComparePrice = true;
            console.log('  📊 Compare price detected - finding main price outside compare spans');
            
            // Clone element and remove compare spans to isolate main price
            const tempElement = subtitleElement.cloneNode(true);
            const tempCompareSpans = tempElement.querySelectorAll('span[class*="compare"], span[class*="Compare"], span[style*="text-decoration"], span[style*="line-through"]');
            tempCompareSpans.forEach(span => span.remove());
            
            const mainPriceText = tempElement.textContent.trim();
            const mainPriceMatch = mainPriceText.match(/\d+(\.\d+)?/);
            
            if (mainPriceMatch) {
              numberToMultiply = parseFloat(mainPriceMatch[0]);
              console.log(`  💰 Main price found: $${numberToMultiply}`);
            }
          } else {
            // Scenario 2: No compare price - simple single price
            console.log('  💵 Single price detected');
            
            const numberMatch = subtitleText.match(/\d+(\.\d+)?/);
            if (numberMatch) {
              numberToMultiply = parseFloat(numberMatch[0]);
              console.log(`  💰 Single price found: $${numberToMultiply}`);
            }
          }
          
          if (numberToMultiply) {
            const multipliedNumber = numberToMultiply * 2;
            console.log(`  🔢 $${numberToMultiply} × 2 = $${multipliedNumber}`);
            
            if (isComparePrice) {
              // Replace only the main price, preserve compare price spans
              const currentHTML = subtitleElement.innerHTML;
              
              // Find the main price text outside of any spans and replace it
              const tempDiv = document.createElement('div');
              tempDiv.innerHTML = currentHTML;
              
              // Get text nodes that are direct children (not inside spans)
              const walker = document.createTreeWalker(
                tempDiv,
                NodeFilter.SHOW_TEXT,
                {
                  acceptNode: function(node) {
                    // Accept text nodes that are not inside compare price spans
                    let parent = node.parentNode;
                    while (parent && parent !== tempDiv) {
                      if (parent.classList && (
                        parent.classList.toString().toLowerCase().includes('compare') ||
                        parent.style.textDecoration ||
                        parent.style.lineThrough
                      )) {
                        return NodeFilter.FILTER_REJECT;
                      }
                      parent = parent.parentNode;
                    }
                    return NodeFilter.FILTER_ACCEPT;
                  }
                }
              );
              
              let textNode;
              while (textNode = walker.nextNode()) {
                if (textNode.textContent.includes(numberToMultiply.toString())) {
                  textNode.textContent = textNode.textContent.replace(
                    new RegExp(`\\$?${numberToMultiply.toString().replace('.', '\\.')}`),
                    `$${multipliedNumber}`
                  );
                  break;
                }
              }
              
              subtitleElement.innerHTML = tempDiv.innerHTML;
              console.log(`  ✅ Updated main price to $${multipliedNumber} (preserved compare price)`);
            } else {
              // Simple replacement for single price - ensure $ is included
              const hasExistingDollar = subtitleText.includes('$');
              const newPrice = hasExistingDollar ? 
                subtitleText.replace(/\$?\d+(\.\d+)?/, `$${multipliedNumber}`) :
                subtitleText.replace(/\d+(\.\d+)?/, `$${multipliedNumber}`);
                
              subtitleElement.textContent = newPrice;
              console.log(`  ✅ Updated single price to $${multipliedNumber}`);
            }
            
          } else {
            console.log('  ❌ No valid price found to multiply');
          }
        } else {
          console.log('  ✗ Title does not contain "(3-Month)"');
        }
      } else {
        console.log(`\n  Tile ${index + 2} (Div ${divIndex + 1}): Missing title or subtitle element`);
      }
    });
  });

  // Alternative version that returns an array of results from ALL expanded divs
  function getProcessedProductData() {
    const expandedDivs = document.querySelectorAll('div[data-is-expanded="true"]');
    const allResults = [];
    
    expandedDivs.forEach((expandedDiv, divIndex) => {
      const allProductTiles = expandedDiv.querySelectorAll(':scope > .tolstoy-product-tile');
      const productTilesFromSecond = Array.from(allProductTiles).slice(1);
      
      productTilesFromSecond.forEach((tile, index) => {
        const titleElement = tile.querySelector('.tolstoy-product-tile-title');
        const subtitleElement = tile.querySelector('.tolstoy-product-tile-subtitle');
        
        if (titleElement && subtitleElement) {
          const titleText = titleElement.textContent.trim();
          const subtitleText = subtitleElement.textContent.trim();
          
          const result = {
            divIndex: divIndex + 1,
            tileIndex: index + 2,
            title: titleText,
            subtitle: subtitleText,
            hasThreeMonth: titleText.includes('(3-Month)'),
            multipliedValue: null
          };
          
          if (result.hasThreeMonth) {
            // Check if there are compare price elements
            const compareSpans = subtitleElement.querySelectorAll('span[class*="compare"], span[class*="Compare"], span[style*="text-decoration"], span[style*="line-through"]');
            
            let numberToMultiply = null;
            let isComparePrice = false;
            
            if (compareSpans.length > 0) {
              // Scenario 1: Has compare price - get main price OUTSIDE the compare span
              isComparePrice = true;
              
              const tempElement = subtitleElement.cloneNode(true);
              const tempCompareSpans = tempElement.querySelectorAll('span[class*="compare"], span[class*="Compare"], span[style*="text-decoration"], span[style*="line-through"]');
              tempCompareSpans.forEach(span => span.remove());
              
              const mainPriceText = tempElement.textContent.trim();
              const mainPriceMatch = mainPriceText.match(/\d+(\.\d+)?/);
              
              if (mainPriceMatch) {
                numberToMultiply = parseFloat(mainPriceMatch[0]);
              }
            } else {
              // Scenario 2: No compare price - simple single price
              const numberMatch = subtitleText.match(/\d+(\.\d+)?/);
              if (numberMatch) {
                numberToMultiply = parseFloat(numberMatch[0]);
              }
            }
            
            if (numberToMultiply) {
              result.multipliedValue = numberToMultiply * 2;
              
              // Update the actual DOM element
              if (isComparePrice) {
                // Replace only the main price, preserve compare price spans
                const currentHTML = subtitleElement.innerHTML;
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = currentHTML;
                
                const walker = document.createTreeWalker(
                  tempDiv,
                  NodeFilter.SHOW_TEXT,
                  {
                    acceptNode: function(node) {
                      let parent = node.parentNode;
                      while (parent && parent !== tempDiv) {
                        if (parent.classList && (
                          parent.classList.toString().toLowerCase().includes('compare') ||
                          parent.style.textDecoration ||
                          parent.style.lineThrough
                        )) {
                          return NodeFilter.FILTER_REJECT;
                        }
                        parent = parent.parentNode;
                      }
                      return NodeFilter.FILTER_ACCEPT;
                    }
                  }
                );
                
                let textNode;
                while (textNode = walker.nextNode()) {
                  if (textNode.textContent.includes(numberToMultiply.toString())) {
                    textNode.textContent = textNode.textContent.replace(
                      new RegExp(`\\$?${numberToMultiply.toString().replace('.', '\\.')}`),
                      `$${result.multipliedValue}`
                    );
                    break;
                  }
                }
                
                subtitleElement.innerHTML = tempDiv.innerHTML;
              } else {
                const hasExistingDollar = subtitleText.includes('$');
                const newPrice = hasExistingDollar ? 
                  subtitleText.replace(/\$?\d+(\.\d+)?/, `$${result.multipliedValue}`) :
                  subtitleText.replace(/\d+(\.\d+)?/, `$${result.multipliedValue}`);
                  
                subtitleElement.textContent = newPrice;
              }
            }
          }
          
          allResults.push(result);
        }
      });
    });
    
    return allResults;
  }

  // Alternative version that preserves text format (e.g., currency symbols, units)
  function updateSubtitlePreservingFormat() {
    const expandedDivs = document.querySelectorAll('div[data-is-expanded="true"]');
    
    expandedDivs.forEach((expandedDiv, divIndex) => {
      const allProductTiles = expandedDiv.querySelectorAll(':scope > .tolstoy-product-tile');
      const productTilesFromSecond = Array.from(allProductTiles).slice(1);
      
      productTilesFromSecond.forEach((tile, index) => {
        const titleElement = tile.querySelector('.tolstoy-product-tile-title');
        const subtitleElement = tile.querySelector('.tolstoy-product-tile-subtitle');
        
        if (titleElement && subtitleElement) {
          const titleText = titleElement.textContent.trim();
          
          if (titleText.includes('(3-Month)')) {
            // Check if there are compare price elements
            const compareSpans = subtitleElement.querySelectorAll('span[class*="compare"], span[class*="Compare"], span[style*="text-decoration"], span[style*="line-through"]');
            
            let numberToMultiply = null;
            let isComparePrice = false;
            
            if (compareSpans.length > 0) {
              // Scenario 1: Has compare price - get main price OUTSIDE the compare span
              isComparePrice = true;
              
              const tempElement = subtitleElement.cloneNode(true);
              const tempCompareSpans = tempElement.querySelectorAll('span[class*="compare"], span[class*="Compare"], span[style*="text-decoration"], span[style*="line-through"]');
              tempCompareSpans.forEach(span => span.remove());
              
              const mainPriceText = tempElement.textContent.trim();
              const mainPriceMatch = mainPriceText.match(/\d+(\.\d+)?/);
              
              if (mainPriceMatch) {
                numberToMultiply = parseFloat(mainPriceMatch[0]);
              }
            } else {
              // Scenario 2: No compare price - simple single price
              const subtitleText = subtitleElement.textContent.trim();
              const numberMatch = subtitleText.match(/\d+(\.\d+)?/);
              if (numberMatch) {
                numberToMultiply = parseFloat(numberMatch[0]);
              }
            }
            
            if (numberToMultiply) {
              const multipliedNumber = numberToMultiply * 2;
              
              if (isComparePrice) {
                // Replace only the main price, preserve compare price spans
                const currentHTML = subtitleElement.innerHTML;
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = currentHTML;
                
                const walker = document.createTreeWalker(
                  tempDiv,
                  NodeFilter.SHOW_TEXT,
                  {
                    acceptNode: function(node) {
                      let parent = node.parentNode;
                      while (parent && parent !== tempDiv) {
                        if (parent.classList && (
                          parent.classList.toString().toLowerCase().includes('compare') ||
                          parent.style.textDecoration ||
                          parent.style.lineThrough
                        )) {
                          return NodeFilter.FILTER_REJECT;
                        }
                        parent = parent.parentNode;
                      }
                      return NodeFilter.FILTER_ACCEPT;
                    }
                  }
                );
                
                let textNode;
                while (textNode = walker.nextNode()) {
                  if (textNode.textContent.includes(numberToMultiply.toString())) {
                    textNode.textContent = textNode.textContent.replace(
                      new RegExp(`\\$?${numberToMultiply.toString().replace('.', '\\.')}`),
                      `$${multipliedNumber}`
                    );
                    break;
                  }
                }
                
                subtitleElement.innerHTML = tempDiv.innerHTML;
                console.log(`Updated subtitle (preserved compare price): main price $${numberToMultiply} → $${multipliedNumber}`);
              } else {
                // Simple replacement for single price
                const subtitleText = subtitleElement.textContent.trim();
                const hasExistingDollar = subtitleText.includes('$');
                const newPrice = hasExistingDollar ? 
                  subtitleText.replace(/\$?\d+(\.\d+)?/, `$${multipliedNumber}`) :
                  subtitleText.replace(/\d+(\.\d+)?/, `$${multipliedNumber}`);
                  
                subtitleElement.textContent = newPrice;
                console.log(`Updated subtitle from "${subtitleText}" to "${newPrice}"`);
              }
            }
          }
        }
      });
    });
  }

  // Call this if you want to preserve original text formatting:
  // updateSubtitlePreservingFormat();

  // Mutation Observer to watch for DOM changes
  function setupMutationObserver() {
    // Function to process all expanded divs (extracted from main code)
    function processExpandedDivs() {
      const expandedDivs = document.querySelectorAll('div[data-is-expanded="true"]');
      
      if (expandedDivs.length === 0) return;
      
      console.log(`MutationObserver: Found ${expandedDivs.length} expanded divs`);
      
      expandedDivs.forEach((expandedDiv, divIndex) => {
        const allProductTiles = expandedDiv.querySelectorAll(':scope > .tolstoy-product-tile');
        const productTilesFromSecond = Array.from(allProductTiles).slice(1);
        
        productTilesFromSecond.forEach((tile, index) => {
          const titleElement = tile.querySelector('.tolstoy-product-tile-title');
          const subtitleElement = tile.querySelector('.tolstoy-product-tile-subtitle');
          
          if (titleElement && subtitleElement) {
            const titleText = titleElement.textContent.trim();
            const subtitleText = subtitleElement.textContent.trim();
            
            // Skip if already processed (check if it's already a multiplied value)
            if (subtitleElement.dataset.processed === 'true') {
              return;
            }
            
            if (titleText.includes('(3-Month)')) {
              // Check if there are compare price elements
              const compareSpans = subtitleElement.querySelectorAll('span[class*="compare"], span[class*="Compare"], span[style*="text-decoration"], span[style*="line-through"]');
              
              let numberToMultiply = null;
              let isComparePrice = false;
              
              if (compareSpans.length > 0) {
                // Scenario 1: Has compare price - get main price OUTSIDE the compare span
                isComparePrice = true;
                
                const tempElement = subtitleElement.cloneNode(true);
                const tempCompareSpans = tempElement.querySelectorAll('span[class*="compare"], span[class*="Compare"], span[style*="text-decoration"], span[style*="line-through"]');
                tempCompareSpans.forEach(span => span.remove());
                
                const mainPriceText = tempElement.textContent.trim();
                const mainPriceMatch = mainPriceText.match(/\d+(\.\d+)?/);
                
                if (mainPriceMatch) {
                  numberToMultiply = parseFloat(mainPriceMatch[0]);
                }
              } else {
                // Scenario 2: No compare price - simple single price
                const numberMatch = subtitleText.match(/\d+(\.\d+)?/);
                if (numberMatch) {
                  numberToMultiply = parseFloat(numberMatch[0]);
                }
              }
              
              if (numberToMultiply) {
                const multipliedNumber = numberToMultiply * 2;
                
                console.log(`MutationObserver: Processing Tile ${index + 2} (Div ${divIndex + 1})`);
                console.log(`  ${isComparePrice ? 'Compare price scenario' : 'Single price scenario'}: $${numberToMultiply} → $${multipliedNumber}`);
                
                if (isComparePrice) {
                  // Replace only the main price, preserve compare price spans
                  const currentHTML = subtitleElement.innerHTML;
                  const tempDiv = document.createElement('div');
                  tempDiv.innerHTML = currentHTML;
                  
                  const walker = document.createTreeWalker(
                    tempDiv,
                    NodeFilter.SHOW_TEXT,
                    {
                      acceptNode: function(node) {
                        let parent = node.parentNode;
                        while (parent && parent !== tempDiv) {
                          if (parent.classList && (
                            parent.classList.toString().toLowerCase().includes('compare') ||
                            parent.style.textDecoration ||
                            parent.style.lineThrough
                          )) {
                            return NodeFilter.FILTER_REJECT;
                          }
                          parent = parent.parentNode;
                        }
                        return NodeFilter.FILTER_ACCEPT;
                      }
                    }
                  );
                  
                  let textNode;
                  while (textNode = walker.nextNode()) {
                    if (textNode.textContent.includes(numberToMultiply.toString())) {
                      textNode.textContent = textNode.textContent.replace(
                        new RegExp(`\\$?${numberToMultiply.toString().replace('.', '\\.')}`),
                        `$${multipliedNumber}`
                      );
                      break;
                    }
                  }
                  
                  subtitleElement.innerHTML = tempDiv.innerHTML;
                } else {
                  const hasExistingDollar = subtitleText.includes('$');
                  const newPrice = hasExistingDollar ? 
                    subtitleText.replace(/\$?\d+(\.\d+)?/, `$${multipliedNumber}`) :
                    subtitleText.replace(/\d+(\.\d+)?/, `$${multipliedNumber}`);
                    
                  subtitleElement.textContent = newPrice;
                }
                
                // Mark as processed
                subtitleElement.dataset.processed = 'true';
                console.log(`  ✅ Updated to include: $${multipliedNumber}`);
              }
            }
          }
        });
      });
    }
    
    // Create mutation observer
    const observer = new MutationObserver((mutations) => {
      let shouldProcess = false;
      
      mutations.forEach((mutation) => {
        // Check if new nodes were added
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              // Check if added node is or contains expanded div or product tiles
              if (node.matches && (
                node.matches('div[data-is-expanded="true"]') ||
                node.matches('.tolstoy-product-tile') ||
                node.querySelector('div[data-is-expanded="true"]') ||
                node.querySelector('.tolstoy-product-tile')
              )) {
                shouldProcess = true;
              }
            }
          });
        }
        
        // Check if attributes changed (like data-is-expanded)
        if (mutation.type === 'attributes' && 
            mutation.attributeName === 'data-is-expanded' &&
            mutation.target.getAttribute('data-is-expanded') === 'true') {
          shouldProcess = true;
        }
      });
      
      if (shouldProcess) {
        // Small delay to ensure DOM is fully updated
        setTimeout(processExpandedDivs, 100);
      }
    });
    
    // Start observing
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-is-expanded']
    });
    
    console.log('🔍 MutationObserver started - watching for expanded divs and product tiles');
    
    // Process existing elements immediately
    processExpandedDivs();
    
    return observer;
  }

  // Start the mutation observer
  const productTileObserver = setupMutationObserver();

  // To stop the observer later (optional):
  // productTileObserver.disconnect();

  // Usage example:
  // const processedData = getProcessedProductData();
  // console.log('All processed data from all expanded divs:', processedData);

  // Filter only items with 3-Month in title:
  // const threeMonthItems = processedData.filter(item => item.hasThreeMonth);
  // console.log('Only 3-Month items:', threeMonthItems);

  console.log("✅ Product Tile Processor initialized and ready!");
});

/*
🎯 TOLSTOY WIDGET READY - TWO SCENARIOS:

🎯 Scenario 1: Has Compare Price (strikethrough/compare spans)
- Finds main price OUTSIDE the compare price elements
- Only changes the main price, preserves compare price exactly
- Example: "<span>$32.50</span> $28" → "<span>$32.50</span> $56"

🎯 Scenario 2: Single Price (no compare elements) 
- Simple single price detection and replacement
- Example: "$15.99" → "$31.98"

The code intelligently detects which scenario applies and handles accordingly:
✅ Waits for tolstoyWidgetReady event before executing
✅ Adds dollar signs ($) to all price displays
✅ Preserves compare price spans and their styling
✅ Only modifies the actual selling price (main price)
✅ Uses TreeWalker to safely navigate DOM structure
✅ Prevents duplicate processing with data-processed attribute

Perfect for Tolstoy e-commerce widgets with dynamic pricing displays!
*/